import { render, staticRenderFns } from "./ExportPatientDataForm.vue?vue&type=template&id=cc66d312&scoped=true&"
import script from "./ExportPatientDataForm.vue?vue&type=script&lang=js&"
export * from "./ExportPatientDataForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc66d312",
  null
  
)

export default component.exports